import * as angular from 'angular';
import {IController} from "angular";
import {FulfillmentStepDisplayStatusType} from "../../types/fulfillment-step-display-status.type";

export class FulfillmentDisplayStatusMultiSelectComponent implements IController {
  displayStatuses: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  constructor(private $mdSelect) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(FulfillmentStepDisplayStatusType));
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onReset() {
    this.onChange({displayStatuses: []});
    this.$mdSelect.hide();
  }

  onCancel() {
    this.$mdSelect.hide();
  }

  onSelect() {
    this.onChange({displayStatuses: this.displayStatuses});
    this.$mdSelect.hide();
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentDisplayStatusMultiSelect', {
    bindings: {
      displayStatuses: '<',
      noUnderline: '<?',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./fulfillment-display-status-multi-select.html').default,
    controller: FulfillmentDisplayStatusMultiSelectComponent
  });
